import { render, staticRenderFns } from "./ReceiveRequestHistoriesTable.vue?vue&type=template&id=f2ec2b82&scoped=true&lang=pug"
import script from "./ReceiveRequestHistoriesTable.vue?vue&type=script&lang=ts"
export * from "./ReceiveRequestHistoriesTable.vue?vue&type=script&lang=ts"
import style0 from "./ReceiveRequestHistoriesTable.vue?vue&type=style&index=0&id=f2ec2b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ec2b82",
  null
  
)

export default component.exports